import { frequencies, baseRate, minCharge, addOnRates } from './model';

function formatMoney(value) {
  return Math.round(value).toLocaleString('sv-SE');
}

export function computeResult(model) {
  const selectedFreq = frequencies.find((f) => f.id === model.frequency) || frequencies[0];
  const rate = baseRate[model.mode];
  const areaValue = Math.max(Number(model.area) || 0, 0);

  const addOnPerKvm = Object.entries(model.addOns)
    .filter(([, on]) => on)
    .reduce((sum, [key]) => sum + addOnRates[key], 0);

  const baseCost = areaValue * rate * selectedFreq.multiplier;
  const addOnCost = areaValue * addOnPerKvm;

  let subtotal = baseCost + addOnCost;

  const loyaltyEligible = model.loyalty && selectedFreq.id === 'weekly';
  if (loyaltyEligible) {
    subtotal *= 0.9; // 10% rabatt
  }

  let rutDeduction = 0;
  if (model.mode === 'privat') {
    rutDeduction = subtotal * 0.5;
  }

  const afterRut = model.mode === 'privat' ? subtotal - rutDeduction : subtotal;
  const withMin = Math.max(afterRut, minCharge[model.mode]);

  const effectivePerKvm = areaValue > 0 ? Math.round((withMin / areaValue) * 100) / 100 : 0;

  return {
    selectedFreq,
    loyaltyEligible,
    baseCost,
    addOnCost,
    subtotal,
    rutDeduction,
    total: withMin,
    perKvm: effectivePerKvm,
  };
}

export function buildSummary(model, calc) {
  const addOnLabels = {
    windows: 'Fönsterputs',
    floors: 'Golvvård',
    deep: 'Storstäd',
  };

  const selectedAddOns = Object.entries(model.addOns)
    .filter(([, on]) => on)
    .map(([key]) => addOnLabels[key]);

  const lines = [
    `Kundtyp: ${model.mode === 'privat' ? 'Privat (inkl. RUT)' : 'Företag (ex moms)'}`,
    `Yta: ${Math.max(Number(model.area) || 0, 0)} kvm`,
    `Frekvens: ${calc.selectedFreq.label}`,
    `Tillval: ${selectedAddOns.length ? selectedAddOns.join(', ') : 'Inga tillval'}`,
    `Lojalitet: ${calc.loyaltyEligible ? 'Ja, -10% vid veckovis städ' : 'Inte aktiv'}`,
    `Indikativt pris: ${formatMoney(calc.total)} kr (ca ${calc.perKvm} kr/kvm)`,
  ];

  return lines.join('\n');
}

export function toContactUrl(model, calc) {
  const summary = buildSummary(model, calc);
  return `/kontakt?message=${encodeURIComponent(summary)}`;
}
